const BOOL_PARAMS = ['autopause', 'byline', 'controls', 'loop', 'muted', 'playsinline', 'portrait', 'title'];
const ORIGIN = 'https://player.vimeo.com';

function buildSrc(videoId, options) {
  const params = new URLSearchParams();
  for (const key of BOOL_PARAMS) {
    if (key in options) {
      params.set(key, options[key] ? '1' : '0');
    }
  }
  return `${ORIGIN}/video/${videoId}?${params}`;
}

export default class VimeoPlayer {
  constructor(elementOrId, options = {}) {
    this._listeners = {};
    this._ready = false;
    this._readyQueue = [];

    const target = typeof elementOrId === 'string' ? document.getElementById(elementOrId) : elementOrId;

    this.iframe = document.createElement('iframe');
    this.iframe.src = buildSrc(options.id, options);
    this.iframe.allow = 'autoplay; fullscreen';
    this.iframe.setAttribute('frameborder', '0');
    if (options.width) {
      this.iframe.style.width = typeof options.width === 'number' ? `${options.width}px` : options.width;
    }
    this.iframe.style.height = '100%';
    target.appendChild(this.iframe);

    this._onMessage = (e) => {
      if (e.source !== this.iframe?.contentWindow) return;

      let data = e.data;
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch {
          return;
        }
      }

      if (data.event === 'ready') {
        this._ready = true;
        this._readyQueue.forEach((msg) => this.iframe.contentWindow.postMessage(msg, ORIGIN));
        this._readyQueue = [];
        this._emit('loaded', data.data || {});
        return;
      }

      if (data.event) {
        this._emit(data.event, data.data || {});
      }
    };
    window.addEventListener('message', this._onMessage);
  }

  on(event, callback) {
    (this._listeners[event] ??= []).push(callback);
    if (['play', 'pause', 'timeupdate', 'ended'].includes(event)) {
      this._post({ method: 'addEventListener', value: event });
    }
  }

  play() {
    this._post({ method: 'play' });
  }
  pause() {
    this._post({ method: 'pause' });
  }
  setVolume(value) {
    this._post({ method: 'setVolume', value });
  }
  setCurrentTime(value) {
    this._post({ method: 'setCurrentTime', value });
  }

  destroy() {
    window.removeEventListener('message', this._onMessage);
    this.iframe?.remove();
    this.iframe = null;
    this._listeners = {};
    this._readyQueue = [];
  }

  _post(data) {
    if (!this.iframe) return;
    const msg = JSON.stringify(data);
    if (this._ready) {
      this.iframe.contentWindow.postMessage(msg, ORIGIN);
    } else {
      this._readyQueue.push(msg);
    }
  }

  _emit(event, data) {
    (this._listeners[event] || []).forEach((cb) => cb(data));
  }
}
